// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import React, { useEffect, useState } from "react";
// import Logo from "../../../Assets/images/logoh.png";
// import { Button, Col, Row } from "react-bootstrap";
// import { useParams } from "react-router-dom";
// import { Form } from "react-bootstrap";
// import { fetchData } from "../../../Cpanel/Components/Utilities";
// import AvatarImage from "../../../Assets/images/download.png";
// export const ShopProfileLocal = () => {
//   const [shopData, setShopData] = useState([]);
//   const [shopCategoryData, setShopCategoryData] = useState([]);
//   const [buyPrice, setBuyPrice] = useState("");
//   const { id } = useParams();
//   useEffect(() => {
//     const bodyFormData = new FormData();
//     bodyFormData.append("shopid", id);
//     fetchData("shopprofile", bodyFormData, handleApiResponse);
//   }, []);
//   const handleApiResponse = (data) => {
//     setShopData(data);
//     setShopCategoryData(data?.catdata);
//     console.log(data?.data);
//     console.log(data?.catdata);
//   };
//   const shopInfo = shopData?.data?.[0];
//   const shopTypeIdToValue = (shopType) => {
//     if (shopType === 1) {
//       return "اینترنتی";
//     } else if (shopType === 2) {
//       return "حضوری";
//     } else if (shopType === 3) {
//       return "حضوری-اینترنتی";
//     }
//   };
//   return (
//     <div className="mt-5 container">
//       <div className="card wd-75 wm-100 m-auto container">
//         <div className="card-body">
//           {" "}
//           <h2 className="card-title text-center pb-4">
//             <span className="text-warning">
//               {/* <FontAwesomeIcon icon="coins" className="header-icon fs4" /> */}
//             </span>{" "}
//             {shopInfo?.Title} </h2>
//           <div>
//             <div dir="rtl" className="">
//               <Row>
//                 <Col className="col-12 col-lg-6">
//                   {/* <Form.Label className="fw-bold pb-1">
//                     {"لوگو فروشگاه"}
//                   </Form.Label> */}
//                   <img
//                     id="avatar"
//                     className="avatar"
//                     onClick={() => document.getElementById("fileInput").click()}
//                     alt="avatar"
//                     src={!Logo ? `${shopInfo?.url}` : Logo}
//                   />
//                 </Col>
//                 {/* <Col className="col-12 col-lg-6">
//                   {shopData?.qrcode && (
//                     <>
//                       <Form.Label className="fw-bold p-1">
//                         {"QrCode"}
//                       </Form.Label>
//                       <img
//                         id=""
//                         className="qrcode"
//                         // onClick={() => document.getElementById("fileInput").click()}
//                         alt="avatar"
//                         src={
//                           shopData?.qrcode ? `${shopData?.qrcode}` : AvatarImage
//                         }
//                       />
//                     </>
//                   )}
//                 </Col> */}
//               </Row>
//               <div className="panel panel-body">
//                 <Row>
//                   <Col className=" col-12 col-lg-6 pb-2">
//                     <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
//                       <label className="fw-bold"> فروشگاه</label>
//                       <label className="">{shopInfo?.Title}</label>
//                     </div>
//                   </Col>
//                   <Col className=" col-12 col-lg-6 pb-2">
//                     <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
//                       <label className="fw-bold">شماره تماس</label>
//                       <label>{shopTypeIdToValue(shopInfo?.type)}</label>
//                     </div>
//                   </Col>
//                 </Row>
//                 <Row>
//                   <Col className=" col-12 col-lg-6 ">
//                     <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
//                       <label className="fw-bold">آدرس </label>
//                       <label>{shopInfo?.MinimumCashBack}</label>
//                     </div>
//                   </Col>
//                   <Col className=" col-12 col-lg-6 pb-2">
//                     <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
//                       <label className="fw-bold">درباره فروشگاه</label>
//                       <label>{shopInfo?.WebSite}</label>
//                     </div>
//                   </Col>
//                 </Row>
//               </div>
//               <Row className="">
//                 <h4>توضیحات</h4>
//                 <Col className=" col-12 col-lg-6 ">
//                   <div className=" panel panel-body">
//                     <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
//                       <label className="fw-bold">مبلغ خرید </label>
//                       {/* <label className="text-gray">{shopInfo?.MinimumCashBack}</label> */}
//                       <input
//                         type="text"
//                         value={buyPrice}
//                         onChange={(e) => setBuyPrice(e.target.value)}
//                         className="form-control"
//                       />
//                     </div>
//                     <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
//                       <label className="fw-bold">میزان سکه موجود</label>
//                       <label>{shopInfo?.WebSite}</label>
//                     </div>
//                     <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
//                       <label className="fw-bold">میزان سکه پرداختی</label>
//                       <input type="text" className="form-control" />
//                     </div>
//                     <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
//                       <label className="fw-bold">میزان کش بک دریافتی</label>
//                       <label className="text-gray">{shopInfo?.WebSite}</label>
//                     </div>
//                     <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
//                       <label className="fw-bold"> قابل پرداخت</label>
//                       <label>{shopInfo?.WebSite}</label>
//                     </div>
//                   </div>
//                 </Col>
//                 <Col className=" col-12 col-lg-6 ">
//                   <div className="panel panel-body">
//                     <h4 className="mb-5">روش های پرداخت</h4>
//                     <div className="d-flex justify-content-around align-items-center flex-wrap">
//                       <button className="btn btn-outline-danger">Pos</button>
//                       <button className="btn btn-outline-dark">
//                         کارت به کارت
//                       </button>
//                       <Button className="btn btn-success">درگاه بانکی</Button>
//                     </div>
//                   </div>
//                 </Col>
//               </Row>
//               <Row className="mt-4">
//                 <h4>گالری تصاویر</h4>
//                 <div className="panel panel-body">
//                   <Col className=" col-12 col-lg-6 "></Col>
//                 </div>
//               </Row>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import Logo from "../../../Assets/images/logoh.png";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { fetchData } from "../../../Cpanel/Components/Utilities";
import { ShopCardStyle } from "./ShopCardStyle";
import { ShopCategory } from "../../../Cpanel/pages/ShopCategory";
import AvatarImage from "../../../Assets/images/download.png";
import BranchesLoc from "../../../Cpanel/Components/BranchesLoc";
export const ShopProfileLocal = () => {
  const [shopData, setShopData] = useState([]);
  const [shopCategoryData, setShopCategoryData] = useState([]);
  const [showMap, setShowMap] = useState(false);
  const { id } = useParams();
  const [langData, setLangData] = useState("");
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("shopid", id);
    fetchData("shopprofile", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    setShopData(data);
    setShopCategoryData(data?.catdata);
  };
  const handlesetLatLong = (data) => {
    console.log(data, "lat");
    // const [lat, lng] = {...data}

    // console.log(lat,lng)
    setLangData(data);
  };
  const shopInfo = shopData?.data?.[0];
  return (
    <div className="mt-1 container">
      <div className="card wd-75 wm-100 mx-auto ">
        <div className="card-body">
              <Row className=" d-flex justify-content-between align-items-center  px-4">
                <Col className="col-12 col-lg-4">
                  <img
                    id="qrcode"
                    className="qrcode"
                    onClick={() => document.getElementById("fileInput").click()}
                    alt="avatar"
                    src={shopInfo?.MainLogo ? `${shopInfo?.MainLogo}` : Logo}
                  />
                </Col>
                <Col className="col-12 col-lg-4">
                  <h4 className="card-title  ">{shopInfo?.Title} </h4>
                </Col>
                <Col className="col-12 col-lg-4">
                  <Link to={`https://${shopInfo?.WebSite}?R=taab30`}>
                    <button className="btn btn-primary btn-xl px-3 ">
                      ورود به فروشگاه
                    </button>
                  </Link>
                </Col>
              </Row>

                <Row>
                  <Col className=" col-12 col-lg-4 pb-2">
                    <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
                      <label className="fw-bold">شماره تماس</label>
                      <label>{shopInfo?.Tel}</label>
                    </div>
                  </Col>
                  <Col className=" col-12 col-lg-4 ">
                    <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
                      <label className="fw-bold"> کش بک</label>
                      <label>{shopInfo?.MinimumCashBack}</label>
                    </div>
                  </Col>
                  <Col className=" col-12 col-lg-4 pb-2">
                    <div className="m-2 pb-2  rounded  d-flex flex-column justiy-content-between align-items-start  lg:w-50">
                      <label className="fw-bold">درباره فروشگاه</label>
                      <label>{shopInfo?.ShopDesc}</label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className=" col-12 col-lg-4 pb-2">
                    <label className="fw-bold">شبکه های اجتماعی</label>
                    <div className="m-2 pb-2  rounded  d-flex flex-row justiy-content-around align-items-center gap-2  lg:w-50">
                      <div></div>
                      <label>{shopInfo?.MinimumCashBack}</label>
                      <label>{shopInfo?.MinimumCashBack}</label>
                      <label>{shopInfo?.MinimumCashBack}</label>
                      <label>{shopInfo?.MinimumCashBack}</label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <h3 className="">لوکیشن فروشگاه</h3>
                    <BranchesLoc
                      setLatLong={handlesetLatLong}
                      value={langData}
                    />
                </Row>
              </div>
      </div>
    </div>
  );
};
